module.exports = __webpack_public_path__ + "img/redLost.6a06d9c8.svg";